import { logout, signIn} from "@/api/login";
import type { UserInfo, LoginInfo } from '@/types/member';
import type { Nullable } from '@/types/global';
import {TOKEN_KEY,USER_INFO_KEY} from '@/utils/constants'

interface UserState {
  userInfo: Nullable<UserInfo>;
  token?: string;
  // roleList: RoleEnum[];
  // dictItems?: dictType | null;
  sessionTimeout?: boolean;
  lastUpdateTime: number;
  tenantid?: string | number;
  shareTenantId?: Nullable<string | number>;
  loginInfo?: Nullable<LoginInfo>;
}


export const useAuthStore = defineStore('authStore', {
  state: () => ({
       // 用户信息
       userInfo: null,
       // token
       token: undefined,
       // 角色列表
       roleList: [],
       // 字典
       dictItems: null,
       // session过期时间
       sessionTimeout: false,
       // Last fetch time
       lastUpdateTime: 0,
       //租户id
       tenantid: '',
       // 分享租户ID
       // 用于分享页面所属租户与当前用户登录租户不一致的情况
       shareTenantId: null,
       //登录返回信息
       loginInfo: null,
  }),


  actions: {    



    /*** 登出事件*/
    async logoutHandler() {
      await logout()
        .then(() => {     
          
          console.log("logout is successful")     
          // message.success("Logout successful");
        })
        .catch((error) => {
          // message.success("Login failure");
          // 清空本地数据
          // window.location.href = "/";
        })
        .finally(() => {
          this.userInfo = null
          // navigateTo("/");
          localStorage.removeItem(USER_INFO_KEY);
          localStorage.removeItem(TOKEN_KEY);
          window.location.reload();
        });

    },

    setToken(info: string | undefined) {
      this.token = info ? info : ''; // for null or undefined value
    },

    setUserInfo(userInfo){
      this.userInfo = userInfo; // for null or undefined value
    },


    getToken(): string| null {
      return this.token || localStorage.getItem(TOKEN_KEY);
    },

    getUserInfo(){
      const userInfoJson =localStorage.getItem(USER_INFO_KEY)             
      return this.userInfo || (userInfoJson ? JSON.parse(userInfoJson) : null);
    }

  },

//   persist: {
//     enabled: true,
//     strategies: [
//       {
//         key: 'auth',
//         storage: localStorage,
//       },
//     ],
//   },

});